import React, { useState, useEffect } from 'react';
import RotationItem from './RotationItem';
import TaskHistoryModal from './TaskHistoryModal';

const RotationList = ({ participants, locations, tasks, setTasks }) => {
  //const [activeTasks, setActiveTasks] = useState([]); 
  const [filteredParticipant, setFilteredParticipant] = useState('all');
  const [filteredParticipants, setFilteredParticipants] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  //const [tasks, setTasks] = useState([]);

  // Generar combinaciones de tareas
  const generateCombinations = () => {
    if (tasks.length === 0) {
      const combinations = [];
      let day = 1;

      const numOfDays = Math.ceil(locations.length / participants.length);

      for (let dayIndex = 0; dayIndex < numOfDays; dayIndex++) {
        for (let i = 0; i < participants.length; i++) {
          const location = locations[(dayIndex * participants.length + i) % locations.length];
          combinations.push({
            participant: participants[i],
            location: location,
            day: day + dayIndex,
            postponements: 0,
            status: 'Pendiente'
          });
        }
      }
    

      setTasks(combinations);
    //setActiveTasks(combinations);
    }
  };

  // Marcar tarea como completada
  const handleTaskComplete = (task) => {
    setTasks((prevTasks) => {
      const updatedTasks = prevTasks.map((t) =>
        t.participant.id === task.participant.id &&
        t.location.id === task.location.id &&
        t.day === task.day
          ? { ...t, status: 'Completado' }
          : t
      );
      localStorage.setItem('tasks', JSON.stringify(updatedTasks)); // Actualiza el localStorage
      return updatedTasks;
    });
  };

  // Posponer tarea al día siguiente
  const handleTaskPostpone = (task) => {
    setTasks((prevTasks) => {
      const updatedTasks = prevTasks.map((t) =>
        t.participant.id === task.participant.id &&
        t.location.id === task.location.id &&
        t.day === task.day
          ? { ...t, day: t.day + 1, postponements: t.postponements + 1, status: 'Pospuesto' }
          : t
      );
      localStorage.setItem('tasks', JSON.stringify(updatedTasks)); // Actualiza el localStorage
      return updatedTasks;
    });
  };

  //NO FUNCIONA
  // Transferir tarea a otro participante
  /*const handleTaskTransfer = (oldParticipant, newParticipant, location, day, payment) => {
    setActiveTasks((prevTasks) =>
      prevTasks.map((task) =>
        task.participant.id === oldParticipant.id && task.location.id === location.id && task.day === day
          ? { ...task, participant: newParticipant }
          : task
      )
    );
    setTasks((prevTasks) => [
      ...prevTasks,
      { participant: newParticipant, location, day, postponements: 0, status: `Transferido a cambio de ${payment}` },
    ]);
  };*/

  // Abrir o cerrar modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    // Si no hay tareas, genera nuevas combinaciones
    if (tasks.length === 0) {
      generateCombinations();
    }

    // Extraer los participantes únicos desde las tareas
    const uniqueParticipantIds = Array.from(new Set(tasks.map(task => task.participant.id)));
    const uniqueParticipants = uniqueParticipantIds.map(id => tasks.find(task => task.participant.id === id).participant);
    setFilteredParticipants(uniqueParticipants);

    // generateCombinations se recrea en cada render y llama a setTasks, así que
    // incluirlo aquí realimentaría el efecto. Depende solo de tasks a propósito.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasks]);

  const filteredTasks = filteredParticipant === 'all'
    ? tasks.filter(task => task.status !== 'Completado')
    : tasks.filter(task => task.participant.id === parseInt(filteredParticipant) && task.status !== 'Completado');

  return (
    <div className="container relative">
      <h2 className="text-3xl font-bold mb-6 text-center">Asignaciones</h2>

      {/* Filtro por participante */}
      <div className="mb-6 flex justify-center">
        <label htmlFor="participant-filter" className="mr-2 font-semibold">Filtrar por participante:</label>
        <select
          id="participant-filter"
          value={filteredParticipant}
          onChange={(e) => setFilteredParticipant(e.target.value)}
          className="p-2 border rounded-lg"
        >
          <option value="all">Todos</option>
          {filteredParticipants.map(participant => (
            <option key={participant.id} value={participant.id}>
              {participant.name}
            </option>
          ))}
        </select>
      </div>

      {/* Contenedor con scroll para las asignaciones */}
      <div className="flex flex-col gap-4 ">
        {filteredTasks.map((task) => (
          <RotationItem
            key={`${task.participant.id}-${task.location.id}-${task.day}`}
            task={task}
            onTaskComplete={handleTaskComplete}
            onTaskPostpone={handleTaskPostpone}
          />
        ))}
      </div>

      {/* Modal para mostrar el historial de tareas */}
      <TaskHistoryModal isOpen={isModalOpen} toggleModal={toggleModal} tasks={tasks} />
    </div>
  );
};

export default RotationList;
